import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Panel from '../SharedComponents/Panel/Panel';
import BaseModal from '../SharedComponents/BaseModal/BaseModal';
import CMSContent from '../SharedComponents/CMSContent/CMSContent';

import { getCampaignOpenStatus } from '../../../utils/campaignState';
import analytics, { events } from '../../../utils/analytics';
import { getUserRole, getSubscriptiontate } from '../../../utils/user';
import { getDeviceType } from '../../../utils/device';
import env from '../../../utils/env';

import { getBoostCampaign } from '../../../modules/boost';
import OrderSummary from '../SharedComponents/OrderSummary/OrderSummary';
import { getCartSum, getTotalQty, showOrderSummary } from '../SharedComponents/utils/helperFuncs';
import Button, { actionTypes, buttonTypes } from '@bit/fabfitfun.shared.global.button';

class BoostView extends Component {
  state = {
    isModalOpen: false,
  };

  componentDidMount() {
    this.props.getBoostCampaign();
  }

  toggleModal = () => {
    this.setState(state => (
      { isModalOpen: !state.isModalOpen }
    ));
  }

  getTrackingData = () => {
    const { sysdata, boostCampaign } = this.props;
    const { userData } = sysdata;
    return {
      user_id: userData.wooId,
      role: getUserRole(userData.select),
      subscription_state: getSubscriptiontate(userData.subscriptions),
      campaign_id: boostCampaign.id,
      campaign_name: boostCampaign.name,
      device: getDeviceType(),
    };
  }

  handleClickLearnMore = () => {
    analytics.track(events.CLICKED_ELEMENT, {
      ...this.getTrackingData(),
      experience: 'My Box',
      element_name: 'LEARN MORE',
    });
    this.toggleModal();
  }

  handleClickCheckItOut = () => {
    analytics.track(events.CLICKED_ELEMENT, {
      ...this.getTrackingData(),
      experience: 'My Box',
      element_name: 'CHECK IT OUT',
    });
    window.location = `${env.envURL}/boost/`;
  }

  handleClickCloseModal = () => {
    analytics.track(events.CLICKED_ELEMENT, {
      ...this.getTrackingData(),
      experience: 'My Box',
      element_name: 'OK GOT IT',
    });
    this.toggleModal();
  }

  handleClickAddMore = () => {
    analytics.track(events.CLICKED_ELEMENT,{
      ...this.getTrackingData(),
      experience: 'My Box Summary',
      element_name: 'ADD MORE',
    });
    window.location = `${env.envURL}/boost/`;
  }

  render() {
    const { sysdata = {}, boostCampaign } = this.props;
    const { boxData = {} } = sysdata;
    const { isModalOpen } = this.state;
    const panelName = 'Box Boost';
    const cmsData = {
      callBacks: {
        Button_y101c73dc_03ef_4f5c_8662_5530f1bdfbe0: this.handleClickCheckItOut,
        Button_a40572d4b_a2e8_4a50_83c6_4e7f30ca59d5: this.handleClickLearnMore,
        Button_b339ece4a_7ef7_41fd_9a39_cb7dfe6ffbec: this.handleClickCloseModal,
      },
    };

    return (
      <React.Fragment>
        <Panel
          sysdata={sysdata}
          panelItems={boxData.boostItems}
          panelName={panelName}
          displayOrderSummary={showOrderSummary(boxData)}
          status={getCampaignOpenStatus(boostCampaign)}
          isBoost
          hasBeenAssigned // set to true so 'view item' url goes to product instead of addons link
          orderSummary={(
            <OrderSummary
              title={panelName}
              total={getTotalQty(boxData.boostItems)}
              sum={getCartSum(boxData.boostItems)}
              footnote="Total does not reflect credit applied."
            />
          )}
          addMore={(
            <Button
              label="Add More"
              style={{ width: '100%', margin: '12px 0 0' }}
              onClick={this.handleClickAddMore}
            />
          )}
          closedCTA={<CMSContent id={115} sysdata={cmsData} />}
          noItemCTA={<CMSContent id={116} sysdata={cmsData} />}
        />
        <BaseModal
          isOpen={isModalOpen}
          onRequestClose={this.toggleModal}
          styles={{ padding: 0 }}
        >
          <CMSContent id={117} sysdata={cmsData} />
        </BaseModal>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    boostCampaign: state.boost.campaign,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getBoostCampaign,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(BoostView);



// WEBPACK FOOTER //
// ./src/Components/Panels/BoostPanel/BoostPanel.js